import { AverageHoldingTime, AverageReturn } from './components/AverageStats'
import { Overview } from './components/Overview'
import { PopularTrades } from './components/PopularTrades'
import { TopTrades } from './components/TopTrades'
import { YourMarkets } from './components/YourMarkets'
import s from './styles.module.scss'
export const Analytics = () => {
  return (
    <div className={s.container}>
      <div className={s.left}>
        <Overview />
        <AverageHoldingTime />
        <AverageReturn />
      </div>
      <div className={s.right}>
        <TopTrades />
        <YourMarkets />
        <PopularTrades />
      </div>
    </div>
  )
}
